export default {
  routes: [
    // 换绑首页
    {
      path: '/changeBindMobile/index',
      name: 'changeMobile',
      meta: {
        desc: '手机号换绑'
      },
      component: () =>
        import(/* webpackChunkName: "changeMobile" */ '../views/changeBindMobile/index.vue')
    },
    {
      path: '/changeBindMobile/verifyOldMobile',
      name: 'verifyOldMobile',
      meta: {
        desc: '手机号换绑'
      },
      component: () =>
        import(
          /* webpackChunkName: "verifyOldMobile" */ '../views/changeBindMobile/verifyOldMobile.vue'
        )
    },
    {
      path: '/changeBindMobile/bindNewMobile',
      name: 'bindNewMobile',
      meta: {
        desc: '手机号换绑'
      },
      component: () =>
        import(
          /* webpackChunkName: "bindNewMobile" */ '../views/changeBindMobile/bindNewMobile.vue'
        )
    }
  ]
}
